import { PrerequisiteLoadingService } from "../sdServices/loading/prerequisite-loading-service";
import { LoggingService } from "../sdServices/loggingSvc";
import { ServiceDeskConfig } from "./serviceDeskConfig";
import { MsalAuthenticationServiceImplementation } from "../sdServices/msal/msal-authentication-service";

export type ConfigWithBootstrapState = ng.IRequestConfig & {
  _sd_request_used_msal_too_early?: boolean;
};
export const http401SUppressorError =
  "A service is being called before the application is bootstrapped. This can cause MSAL looping behavior. This will happen on every token renewal or reauth. URL:";
export let unauthorizedRequestBroadcast = "unauthorizedRequestBroadcast";
export class HttpInterceptor401Suppressor {
  private prerequisiteLoadingService: PrerequisiteLoadingService;
  private loggingService: LoggingService;
  // @ngInject
  constructor(
    private $injector: ng.auto.IInjectorService,
    private $delegate: ng.IHttpInterceptor,
    private msalAuthenticationService: MsalAuthenticationServiceImplementation,
    private $rootScope: ng.IRootScopeService,
    sdConfig: ServiceDeskConfig
  ) {
    // In order to preserve the behavior of 'arguments', we implement the request / response methods below. We need to preserve appropriate reference to the 'this' variable.
    let instance = this;
    this.request = function (config: ConfigWithBootstrapState) {
      if (!config) {
        return config;
      }
      instance.ensureServiceInjected();
      config._sd_request_used_msal_too_early =
        !instance.prerequisiteLoadingService.hasFinishedLoadingGlobalPrerequisites &&
        !instance.msalAuthenticationService.userInfo.isAuthenticated &&
        instance.msalConfigAppliesToRequest(config, sdConfig);
      if (config._sd_request_used_msal_too_early) {
        let errorMessage = http401SUppressorError + config.url;
        instance.loggingService.logError(errorMessage);
        if (window == window.top) {
          let $state: angular.ui.IStateService = <any>$injector.get("$state");
          if ($state.current.name != "sdSystem.error") {
            $state.go("sdSystem.error", { errorParams: { error: errorMessage } });
          }
        }
        throw errorMessage;
      }
      return instance.$delegate.request.apply(instance.$delegate, arguments);
    };

    this.responseError = function (rejection: { config: ConfigWithBootstrapState } & ng.IHttpPromiseCallbackArg<{}>) {
      if (rejection && rejection.config && rejection.config._sd_request_used_msal_too_early == true) {
        return rejection;
      } else if (rejection && rejection.status && rejection.status == 401 && rejection.config && rejection.config.url) {
        let url = rejection.config.url;
        let rejectedResource = instance.msalAuthenticationService.getScopesForEndpoint(
          url,
          this.sdConfig.getMsalConfig().optionalParams.protectedResourceMap
        );
        instance.$rootScope.$broadcast(unauthorizedRequestBroadcast, url, rejectedResource);
        return rejection;
      } else {
        return instance.$delegate.responseError.apply(instance.$delegate, arguments);
      }
    };
  }

  private ensureServiceInjected() {
    if (this.prerequisiteLoadingService) {
      return;
    }
    this.prerequisiteLoadingService = this.$injector.get<PrerequisiteLoadingService>("prerequisiteLoadingService");
    this.loggingService = this.$injector.get<LoggingService>("loggingService");
  }

  private msalConfig: any;
  private msalConfigAppliesToRequest(config: ng.IRequestConfig, sdConfig: ServiceDeskConfig) {
    if (!this.msalConfig) {
      this.msalConfig = sdConfig.getMsalConfig();
    }

    // for (let configEndpoint in this.msalConfig.endpoints) {
    //   if (config.url.includes(configEndpoint)) {
    //     return !!this.msalConfig.endpoints[configEndpoint];
    //   }
    // }

    return false;
  }

  public request: (config: ConfigWithBootstrapState) => ConfigWithBootstrapState;
  public responseError: (rejection: { config: ConfigWithBootstrapState }) => { config: ConfigWithBootstrapState };
}

// @ngInject
export let decoratorWrapper = (
  $delegate: ng.IHttpInterceptor,
  $injector: ng.auto.IInjectorService,
  msalAuthenticationService: any,
  $rootScope: ng.IRootScopeService,
  sdConfig: ServiceDeskConfig
) => {
  return new HttpInterceptor401Suppressor($injector, $delegate, msalAuthenticationService, $rootScope, sdConfig);
};
